/** Agent withdraw page — non-English overrides */
export const panelAgentWithdrawByLang = {
  es: {
    'agent.withdraw.form.title': 'Retirar comisión',
    'agent.withdraw.form.lockedTitle': 'Retiros bloqueados',
    'agent.withdraw.form.lockedHint': 'Completa los requisitos de referidos para desbloquear',
    'agent.withdraw.form.viewRequirements': 'Ver requisitos',
    'agent.withdraw.form.availableLabel': 'Disponible para retirar',
    'agent.withdraw.form.pending': 'Pendiente: {{amount}}',
    'agent.withdraw.form.paidOut': 'Pagado: {{amount}}',
    'agent.withdraw.form.walletLabel': 'Dirección de billetera USDT TRC20',
    'agent.withdraw.form.walletPlaceholder': 'Ingresa la dirección de billetera',
    'agent.withdraw.form.walletHint': 'Retiros de agente solo a USDT TRC20. Sin comisiones de plataforma.',
    'agent.withdraw.form.amountLabel': 'Monto',
    'agent.withdraw.form.amountPlaceholder': '0.00',
    'agent.withdraw.form.availableLine': 'Available: {{amount}}',
    'agent.withdraw.form.requestCta': 'Solicitar retiro',
    'agent.withdraw.form.submitting': 'Submitting…',
    'agent.withdraw.toast.walletRequired': 'La dirección de billetera es obligatoria',
    'agent.withdraw.toast.amountInvalid': 'Ingresa un monto válido',
    'agent.withdraw.toast.amountExceeds': 'El monto supera el saldo disponible',
    'agent.withdraw.toast.loadFail': 'No se pudieron cargar los retiros',
    'agent.withdraw.toast.submitFail': 'No se pudo enviar el retiro',
    'agent.withdraw.toast.submitted': 'Solicitud de retiro enviada',
    'agent.withdraw.unlock.titleUnlocked': 'Los retiros están desbloqueados',
    'agent.withdraw.unlock.titleLocked': 'Los retiros están bloqueados',
    'agent.withdraw.unlock.subtitle': 'Completa ambos requisitos para activar tu sistema de retiros',
    'agent.withdraw.unlock.directLabel': 'Referidos directos requeridos',
    'agent.withdraw.unlock.indirectLabel': 'Referidos indirectos requeridos',
    'agent.withdraw.unlock.loading': 'Cargando…',
    'agent.withdraw.unlock.loadingTitle': 'Comprobando estado de retiros…',
    'agent.withdraw.unlock.loadingSubtitle': 'Cargando tu progreso de referidos y requisitos de desbloqueo',
    'agent.withdraw.form.loadingTitle': 'Cargando datos de retiro…',
    'agent.withdraw.form.loadingHint': 'Espera mientras cargamos tu saldo y estado de desbloqueo',
    'agent.withdraw.unlock.pctComplete': '{{pct}}% completado',
    'agent.withdraw.unlock.moreNeeded': '{{n}} más necesarios',
    'agent.withdraw.unlock.requirementMet': 'Requisito cumplido',
    'agent.withdraw.unlock.badgeUnlocked': 'Retiros desbloqueados',
    'agent.withdraw.unlock.badgeLocked': 'Retiros bloqueados',
    'agent.withdraw.unlock.footerHint': 'Deben cumplirse ambos requisitos',
    'agent.withdraw.unlock.minDepositHint':
      'Solo cuentan usuarios referidos (no sub-agentes). Cada uno debe tener al menos ${{amount}} en depósitos completados.',
    'agent.withdraw.confirm.title': 'Confirmar retiro',
    'agent.withdraw.confirm.amount': 'Monto del retiro',
    'agent.withdraw.confirm.fee': 'Comisión de plataforma',
    'agent.withdraw.confirm.noFee': 'Sin comisión',
    'agent.withdraw.confirm.net': 'Recibirás',
    'agent.withdraw.confirm.submitting': 'Submitting…',
    'agent.withdraw.confirm.confirm': 'Confirmar',
    'agent.withdraw.rules.title': 'Reglas de retiro',
    'agent.withdraw.rules.rule1': 'Disponible cada 30 días desde la activación de la cuenta',
    'agent.withdraw.rules.rule2': 'Solo se puede retirar el saldo de comisiones — los agentes no invierten capital',
    'agent.withdraw.rules.rule3': 'Solo a billetera USDT TRC20 — sin otros métodos',
    'agent.withdraw.rules.rule4': 'Sin comisiones de plataforma en retiros de agente',
    'agent.withdraw.rules.rule5': 'Ambos requisitos de referidos deben cumplirse antes del primer retiro',
    'agent.withdraw.rules.processingNote': 'Las solicitudes se revisan y procesan en 24–48 horas tras el envío.',
    'agent.withdraw.rules.windowActive': 'La ventana de retiro está activa. Puedes enviar solicitudes ahora.',
    'agent.withdrawLogs.sectionTitle': 'Historial de retiros',
    'agent.withdrawLogs.loading': 'Loading withdrawals…',
    'agent.withdrawLogs.emptyTitle': 'Aún no hay retiros',
    'agent.withdrawLogs.emptyDesc': 'Tu historial de retiros aparecerá aquí',
    'agent.withdrawLogs.emptyLoadingHint': 'Please wait…',
    'agent.withdrawLogs.col.date': 'Date',
    'agent.withdrawLogs.col.amount': 'Amount',
    'agent.withdrawLogs.col.wallet': 'Dirección de billetera',
    'agent.withdrawLogs.col.status': 'Status',
    'agent.withdrawLogs.col.txid': 'TXID',
    'agent.withdrawLogs.showingCount': 'Mostrando {{n}} retiros',
  },
  de: {
    'agent.withdraw.form.title': 'Provision auszahlen',
    'agent.withdraw.form.lockedTitle': 'Auszahlungen gesperrt',
    'agent.withdraw.form.lockedHint': 'Empfehlungsanforderungen erfüllen zum Freischalten',
    'agent.withdraw.form.viewRequirements': 'Anforderungen anzeigen',
    'agent.withdraw.form.availableLabel': 'Zur Auszahlung verfügbar',
    'agent.withdraw.form.pending': 'Ausstehend: {{amount}}',
    'agent.withdraw.form.paidOut': 'Ausgezahlt: {{amount}}',
    'agent.withdraw.form.walletLabel': 'USDT TRC20 Wallet-Adresse',
    'agent.withdraw.form.walletPlaceholder': 'Wallet-Adresse eingeben',
    'agent.withdraw.form.walletHint': 'Agentenauszahlungen nur an USDT TRC20. Keine Plattformgebühren.',
    'agent.withdraw.form.amountLabel': 'Betrag',
    'agent.withdraw.form.amountPlaceholder': '0.00',
    'agent.withdraw.form.availableLine': 'Available: {{amount}}',
    'agent.withdraw.form.requestCta': 'Auszahlung anfordern',
    'agent.withdraw.form.submitting': 'Submitting…',
    'agent.withdraw.toast.walletRequired': 'Wallet-Adresse ist erforderlich',
    'agent.withdraw.toast.amountInvalid': 'Gültigen Betrag eingeben',
    'agent.withdraw.toast.amountExceeds': 'Amount exceeds available balance',
    'agent.withdraw.toast.loadFail': 'Failed to load withdrawals',
    'agent.withdraw.toast.submitFail': 'Auszahlung konnte nicht gesendet werden',
    'agent.withdraw.toast.submitted': 'Auszahlungsanfrage gesendet',
    'agent.withdraw.unlock.titleUnlocked': 'Auszahlungen sind freigeschaltet',
    'agent.withdraw.unlock.titleLocked': 'Auszahlungen sind derzeit gesperrt',
    'agent.withdraw.unlock.subtitle': 'Erfüllen Sie beide Anforderungen unten, um Auszahlungen zu aktivieren',
    'agent.withdraw.unlock.directLabel': 'Direkte Empfehlungen erforderlich',
    'agent.withdraw.unlock.indirectLabel': 'Indirekte Empfehlungen erforderlich',
    'agent.withdraw.unlock.loading': 'Wird geladen…',
    'agent.withdraw.unlock.loadingTitle': 'Auszahlungsstatus wird geprüft…',
    'agent.withdraw.unlock.loadingSubtitle': 'Empfehlungsfortschritt und Freischaltungsanforderungen werden geladen',
    'agent.withdraw.form.loadingTitle': 'Auszahlungsdetails werden geladen…',
    'agent.withdraw.form.loadingHint': 'Bitte warten — Guthaben und Freischaltungsstatus werden geladen',
    'agent.withdraw.unlock.pctComplete': '{{pct}}% abgeschlossen',
    'agent.withdraw.unlock.moreNeeded': 'noch {{n}}',
    'agent.withdraw.unlock.requirementMet': 'Anforderung erfüllt',
    'agent.withdraw.unlock.badgeUnlocked': 'Auszahlungen freigeschaltet',
    'agent.withdraw.unlock.badgeLocked': 'Auszahlungen gesperrt',
    'agent.withdraw.unlock.footerHint': 'Beide Anforderungen müssen erfüllt sein',
    'agent.withdraw.unlock.minDepositHint':
      'Nur geworbene Nutzer (keine Sub-Agenten). Mindestens ${{amount}} abgeschlossene Einzahlungen pro Nutzer.',
    'agent.withdraw.confirm.title': 'Auszahlung bestätigen',
    'agent.withdraw.confirm.amount': 'Auszahlungsbetrag',
    'agent.withdraw.confirm.fee': 'Plattformgebühr',
    'agent.withdraw.confirm.noFee': 'Keine Gebühr',
    'agent.withdraw.confirm.net': 'Sie erhalten',
    'agent.withdraw.confirm.submitting': 'Submitting…',
    'agent.withdraw.confirm.confirm': 'Bestätigen',
    'agent.withdraw.rules.title': 'Auszahlungsregeln',
    'agent.withdraw.rules.rule1': 'Alle 30 Tage ab Kontaktivierung verfügbar',
    'agent.withdraw.rules.rule2': 'Nur Provisionsguthaben auszahlbar — Agenten investieren kein Kapital',
    'agent.withdraw.rules.rule3': 'Nur an USDT TRC20 Wallet — keine anderen Methoden',
    'agent.withdraw.rules.rule4': 'Keine Plattformgebühren bei Agentenauszahlungen',
    'agent.withdraw.rules.rule5': 'Beide Empfehlungsanforderungen vor der ersten Auszahlung erfüllen',
    'agent.withdraw.rules.processingNote': 'Anfragen werden innerhalb von 24–48 Stunden nach Einreichung bearbeitet.',
    'agent.withdraw.rules.windowActive': 'Auszahlungsfenster ist aktiv. Sie können jetzt Anfragen senden.',
    'agent.withdrawLogs.sectionTitle': 'Auszahlungsverlauf',
    'agent.withdrawLogs.loading': 'Loading withdrawals…',
    'agent.withdrawLogs.emptyTitle': 'Noch keine Auszahlungen',
    'agent.withdrawLogs.emptyDesc': 'Ihr Auszahlungsverlauf erscheint hier',
    'agent.withdrawLogs.emptyLoadingHint': 'Please wait…',
    'agent.withdrawLogs.col.date': 'Date',
    'agent.withdrawLogs.col.amount': 'Amount',
    'agent.withdrawLogs.col.wallet': 'Wallet-Adresse',
    'agent.withdrawLogs.col.status': 'Status',
    'agent.withdrawLogs.col.txid': 'TXID',
    'agent.withdrawLogs.showingCount': '{{n}} Auszahlungen angezeigt',
  },
  fr: {
    'agent.withdraw.form.title': 'Retirer la commission',
    'agent.withdraw.form.lockedTitle': 'Retraits verrouillés',
    'agent.withdraw.form.lockedHint': 'Remplissez les exigences de parrainage pour débloquer',
    'agent.withdraw.form.viewRequirements': 'Voir les exigences',
    'agent.withdraw.form.availableLabel': 'Disponible pour retrait',
    'agent.withdraw.form.pending': 'En attente : {{amount}}',
    'agent.withdraw.form.paidOut': 'Payé : {{amount}}',
    'agent.withdraw.form.walletLabel': 'Adresse portefeuille USDT TRC20',
    'agent.withdraw.form.walletPlaceholder': 'Saisir l\'adresse du portefeuille',
    'agent.withdraw.form.walletHint': 'Retraits agent uniquement en USDT TRC20. Aucun frais plateforme.',
    'agent.withdraw.form.amountLabel': 'Montant',
    'agent.withdraw.form.amountPlaceholder': '0,00',
    'agent.withdraw.form.availableLine': 'Disponible : {{amount}}',
    'agent.withdraw.form.requestCta': 'Demander un retrait',
    'agent.withdraw.form.submitting': 'Envoi…',
    'agent.withdraw.toast.walletRequired': 'L\'adresse du portefeuille est requise',
    'agent.withdraw.toast.amountInvalid': 'Saisissez un montant valide',
    'agent.withdraw.toast.amountExceeds': 'Amount exceeds available balance',
    'agent.withdraw.toast.loadFail': 'Failed to load withdrawals',
    'agent.withdraw.toast.submitFail': 'Échec de l\'envoi du retrait',
    'agent.withdraw.toast.submitted': 'Demande de retrait envoyée',
    'agent.withdraw.unlock.titleUnlocked': 'Les retraits sont débloqués',
    'agent.withdraw.unlock.titleLocked': 'Les retraits sont verrouillés',
    'agent.withdraw.unlock.subtitle': 'Remplissez les deux exigences ci-dessous pour activer les retraits',
    'agent.withdraw.unlock.directLabel': 'Parrainages directs requis',
    'agent.withdraw.unlock.indirectLabel': 'Parrainages indirects requis',
    'agent.withdraw.unlock.loading': 'Chargement…',
    'agent.withdraw.unlock.loadingTitle': 'Vérification du statut des retraits…',
    'agent.withdraw.unlock.loadingSubtitle': 'Chargement de votre progression de parrainage et des exigences',
    'agent.withdraw.form.loadingTitle': 'Chargement des détails de retrait…',
    'agent.withdraw.form.loadingHint': 'Veuillez patienter pendant le chargement du solde et du statut',
    'agent.withdraw.unlock.pctComplete': '{{pct}} % terminé',
    'agent.withdraw.unlock.moreNeeded': '{{n}} de plus',
    'agent.withdraw.unlock.requirementMet': 'Exigence remplie',
    'agent.withdraw.unlock.badgeUnlocked': 'Retraits débloqués',
    'agent.withdraw.unlock.badgeLocked': 'Retraits verrouillés',
    'agent.withdraw.unlock.footerHint': 'Les deux exigences doivent être remplies',
    'agent.withdraw.unlock.minDepositHint':
      'Seuls les utilisateurs parrainés comptent (pas les sous-agents). Chacun doit avoir au moins ${{amount}} de dépôts complétés.',
    'agent.withdraw.confirm.title': 'Confirmer le retrait',
    'agent.withdraw.confirm.amount': 'Montant du retrait',
    'agent.withdraw.confirm.fee': 'Frais plateforme',
    'agent.withdraw.confirm.noFee': 'Sans frais',
    'agent.withdraw.confirm.net': 'Vous recevrez',
    'agent.withdraw.confirm.submitting': 'Envoi…',
    'agent.withdraw.confirm.confirm': 'Confirmer',
    'agent.withdraw.rules.title': 'Règles de retrait',
    'agent.withdraw.rules.rule1': 'Disponible tous les 30 jours à partir de l\'activation du compte',
    'agent.withdraw.rules.rule2': 'Seul le solde de commission peut être retiré — les agents n\'investissent pas de capital',
    'agent.withdraw.rules.rule3': 'Uniquement vers un portefeuille USDT TRC20 — pas d\'autres méthodes',
    'agent.withdraw.rules.rule4': 'Aucun frais plateforme sur les retraits agent',
    'agent.withdraw.rules.rule5': 'Les deux exigences de parrainage doivent être remplies avant le premier retrait',
    'agent.withdraw.rules.processingNote': 'Les demandes sont examinées et traitées sous 24 à 48 heures après soumission.',
    'agent.withdraw.rules.windowActive': 'La fenêtre de retrait est active. Vous pouvez envoyer des demandes.',
    'agent.withdrawLogs.sectionTitle': 'Historique des retraits',
    'agent.withdrawLogs.loading': 'Chargement des retraits…',
    'agent.withdrawLogs.emptyTitle': 'Aucun retrait pour l\'instant',
    'agent.withdrawLogs.emptyDesc': 'Votre historique de retraits apparaîtra ici',
    'agent.withdrawLogs.emptyLoadingHint': 'Veuillez patienter…',
    'agent.withdrawLogs.col.date': 'Date',
    'agent.withdrawLogs.col.amount': 'Montant',
    'agent.withdrawLogs.col.wallet': 'Adresse du portefeuille',
    'agent.withdrawLogs.col.status': 'Statut',
    'agent.withdrawLogs.col.txid': 'TXID',
    'agent.withdrawLogs.showingCount': '{{n}} retraits affichés',
  },
  ar: {
    'agent.withdraw.form.title': 'سحب العمولة',
    'agent.withdraw.form.lockedTitle': 'السحوبات مقفلة',
    'agent.withdraw.form.lockedHint': 'أكمل متطلبات الإحالة لفتح السحب',
    'agent.withdraw.form.viewRequirements': 'عرض المتطلبات',
    'agent.withdraw.form.availableLabel': 'متاح للسحب',
    'agent.withdraw.form.pending': 'معلق: {{amount}}',
    'agent.withdraw.form.paidOut': 'مدفوع: {{amount}}',
    'agent.withdraw.form.walletLabel': 'عنوان محفظة USDT TRC20',
    'agent.withdraw.form.walletPlaceholder': 'أدخل عنوان المحفظة',
    'agent.withdraw.form.walletHint': 'سحوبات الوكلاء تُعالَج إلى USDT TRC20 فقط. بدون رسوم منصة.',
    'agent.withdraw.form.amountLabel': 'المبلغ',
    'agent.withdraw.form.amountPlaceholder': '0.00',
    'agent.withdraw.form.availableLine': 'المتاح: {{amount}}',
    'agent.withdraw.form.requestCta': 'طلب سحب',
    'agent.withdraw.form.submitting': 'جاري الإرسال…',
    'agent.withdraw.toast.walletRequired': 'عنوان المحفظة مطلوب',
    'agent.withdraw.toast.amountInvalid': 'أدخل مبلغاً صالحاً',
    'agent.withdraw.toast.amountExceeds': 'Amount exceeds available balance',
    'agent.withdraw.toast.loadFail': 'Failed to load withdrawals',
    'agent.withdraw.toast.submitFail': 'تعذر إرسال طلب السحب',
    'agent.withdraw.toast.submitted': 'تم إرسال طلب السحب',
    'agent.withdraw.unlock.titleUnlocked': 'السحوبات مفعّلة',
    'agent.withdraw.unlock.titleLocked': 'السحوبات مقفلة حالياً',
    'agent.withdraw.unlock.subtitle': 'أكمل الشرطين أدناه لتفعيل نظام السحب',
    'agent.withdraw.unlock.directLabel': 'الإحالات المباشرة المطلوبة',
    'agent.withdraw.unlock.indirectLabel': 'الإحالات غير المباشرة المطلوبة',
    'agent.withdraw.unlock.loading': 'جاري التحميل…',
    'agent.withdraw.unlock.loadingTitle': 'جاري التحقق من حالة السحب…',
    'agent.withdraw.unlock.loadingSubtitle': 'جاري تحميل تقدم الإحالات ومتطلبات فتح السحب',
    'agent.withdraw.form.loadingTitle': 'جاري تحميل تفاصيل السحب…',
    'agent.withdraw.form.loadingHint': 'يرجى الانتظار أثناء تحميل الرصيد وحالة فتح السحب',
    'agent.withdraw.unlock.pctComplete': '{{pct}}% مكتمل',
    'agent.withdraw.unlock.requirementMet': 'تم استيفاء الشرط',
    'agent.withdraw.unlock.moreNeeded': '{{n}} إضافية',
    'agent.withdraw.unlock.badgeUnlocked': 'السحوبات مفعّلة',
    'agent.withdraw.unlock.badgeLocked': 'السحوبات مقفلة',
    'agent.withdraw.unlock.footerHint': 'يجب استيفاء الشرطين',
    'agent.withdraw.unlock.minDepositHint':
      'يُحسب المستخدمون المُحالون فقط (وليس الوكلاء الفرعيون). يجب أن يكون لكل مستخدم ${{amount}} على الأقل من الإيداعات المكتملة.',
    'agent.withdraw.confirm.title': 'تأكيد السحب',
    'agent.withdraw.confirm.amount': 'مبلغ السحب',
    'agent.withdraw.confirm.fee': 'رسوم المنصة',
    'agent.withdraw.confirm.noFee': 'بدون رسوم',
    'agent.withdraw.confirm.net': 'ستستلم',
    'agent.withdraw.confirm.submitting': 'جاري الإرسال…',
    'agent.withdraw.confirm.confirm': 'تأكيد',
    'agent.withdraw.rules.title': 'قواعد السحب',
    'agent.withdraw.rules.rule1': 'متاح كل 30 يوماً من تاريخ تفعيل الحساب',
    'agent.withdraw.rules.rule2': 'يُسحب رصيد العمولات فقط — الوكلاء لا يستثمرون رأس المال',
    'agent.withdraw.rules.rule3': 'إلى محفظة USDT TRC20 فقط — لا طرق أخرى',
    'agent.withdraw.rules.rule4': 'بدون رسوم منصة على سحوبات الوكلاء',
    'agent.withdraw.rules.rule5': 'يجب استيفاء شرطي الإحالة قبل أول سحب',
    'agent.withdraw.rules.processingNote': 'تُراجع طلبات السحب وتُعالَج خلال 24–48 ساعة من الإرسال.',
    'agent.withdraw.rules.windowActive': 'نافذة السحب نشطة. يمكنك إرسال الطلبات الآن.',
    'agent.withdrawLogs.sectionTitle': 'سجل السحوبات',
    'agent.withdrawLogs.loading': 'جاري تحميل السحوبات…',
    'agent.withdrawLogs.emptyTitle': 'لا توجد سحوبات بعد',
    'agent.withdrawLogs.emptyDesc': 'سيظهر سجل السحوبات هنا',
    'agent.withdrawLogs.emptyLoadingHint': 'يرجى الانتظار…',
    'agent.withdrawLogs.col.date': 'التاريخ',
    'agent.withdrawLogs.col.amount': 'المبلغ',
    'agent.withdrawLogs.col.wallet': 'عنوان المحفظة',
    'agent.withdrawLogs.col.status': 'الحالة',
    'agent.withdrawLogs.col.txid': 'TXID',
    'agent.withdrawLogs.showingCount': 'عرض {{n}} سحب',
  },
  ja: {
    'agent.withdraw.form.title': 'コミッションを出金',
    'agent.withdraw.form.lockedTitle': '出金はロック中',
    'agent.withdraw.form.lockedHint': '紹介要件を満たすと出金が解除されます',
    'agent.withdraw.form.viewRequirements': '要件を表示',
    'agent.withdraw.form.availableLabel': '出金可能額',
    'agent.withdraw.form.pending': '保留中: {{amount}}',
    'agent.withdraw.form.paidOut': '支払済み: {{amount}}',
    'agent.withdraw.form.walletLabel': 'USDT TRC20 ウォレットアドレス',
    'agent.withdraw.form.walletPlaceholder': 'ウォレットアドレスを入力',
    'agent.withdraw.form.walletHint': 'エージェント出金は USDT TRC20 のみ。プラットフォーム手数料なし。',
    'agent.withdraw.form.amountLabel': '金額',
    'agent.withdraw.form.amountPlaceholder': '0.00',
    'agent.withdraw.form.availableLine': '利用可能: {{amount}}',
    'agent.withdraw.form.requestCta': '出金を申請',
    'agent.withdraw.form.submitting': '送信中…',
    'agent.withdraw.toast.walletRequired': 'ウォレットアドレスは必須です',
    'agent.withdraw.toast.amountInvalid': '有効な金額を入力してください',
    'agent.withdraw.toast.amountExceeds': 'Amount exceeds available balance',
    'agent.withdraw.toast.loadFail': 'Failed to load withdrawals',
    'agent.withdraw.toast.submitFail': '出金の送信に失敗しました',
    'agent.withdraw.toast.submitted': '出金リクエストを送信しました',
    'agent.withdraw.unlock.titleUnlocked': '出金が解除されました',
    'agent.withdraw.unlock.titleLocked': '出金は現在ロック中',
    'agent.withdraw.unlock.subtitle': '下の2つの要件を満たすと出金が有効になります',
    'agent.withdraw.unlock.directLabel': '必要な直接紹介',
    'agent.withdraw.unlock.indirectLabel': '必要な間接紹介',
    'agent.withdraw.unlock.loading': '読み込み中…',
    'agent.withdraw.unlock.loadingTitle': '出金ステータスを確認中…',
    'agent.withdraw.unlock.loadingSubtitle': '紹介の進捗と解除要件を読み込んでいます',
    'agent.withdraw.form.loadingTitle': '出金情報を読み込み中…',
    'agent.withdraw.form.loadingHint': '残高と解除ステータスの読み込みが完了するまでお待ちください',
    'agent.withdraw.unlock.pctComplete': '{{pct}}% 完了',
    'agent.withdraw.unlock.requirementMet': '要件を達成',
    'agent.withdraw.unlock.moreNeeded': 'あと {{n}}',
    'agent.withdraw.unlock.badgeUnlocked': '出金解除',
    'agent.withdraw.unlock.badgeLocked': '出金ロック',
    'agent.withdraw.unlock.footerHint': '両方の要件を満たす必要があります',
    'agent.withdraw.unlock.minDepositHint':
      '紹介ユーザーのみが対象（サブエージェントは除く）。各ユーザーは完了済み入金が少なくとも ${{amount}} 必要です。',
    'agent.withdraw.confirm.title': '出金を確認',
    'agent.withdraw.confirm.amount': '出金額',
    'agent.withdraw.confirm.fee': 'プラットフォーム手数料',
    'agent.withdraw.confirm.noFee': '手数料なし',
    'agent.withdraw.confirm.net': '受取額',
    'agent.withdraw.confirm.submitting': '送信中…',
    'agent.withdraw.confirm.confirm': '確認',
    'agent.withdraw.rules.title': '出金ルール',
    'agent.withdraw.rules.rule1': 'アカウント有効化日から30日ごとに利用可能',
    'agent.withdraw.rules.rule2': 'コミッション残高のみ出金可能 — エージェントは元本を投資しません',
    'agent.withdraw.rules.rule3': 'USDT TRC20 ウォレットのみ — 他の方法は不可',
    'agent.withdraw.rules.rule4': 'エージェント出金にプラットフォーム手数料なし',
    'agent.withdraw.rules.rule5': '初回出金前に両方の紹介要件を満たす必要があります',
    'agent.withdraw.rules.processingNote': '出金リクエストは送信後24〜48時間以内に審査・処理されます。',
    'agent.withdraw.rules.windowActive': '出金ウィンドウは有効です。今すぐ申請できます。',
    'agent.withdrawLogs.sectionTitle': '出金履歴',
    'agent.withdrawLogs.loading': '出金を読み込み中…',
    'agent.withdrawLogs.emptyTitle': '出金はまだありません',
    'agent.withdrawLogs.emptyDesc': '出金履歴がここに表示されます',
    'agent.withdrawLogs.emptyLoadingHint': 'お待ちください…',
    'agent.withdrawLogs.col.date': '日付',
    'agent.withdrawLogs.col.amount': '金額',
    'agent.withdrawLogs.col.wallet': 'ウォレットアドレス',
    'agent.withdrawLogs.col.status': 'ステータス',
    'agent.withdrawLogs.col.txid': 'TXID',
    'agent.withdrawLogs.showingCount': '{{n}} 件の出金を表示',
  },
  ko: {
    'agent.withdraw.form.title': '커미션 출금',
    'agent.withdraw.form.lockedTitle': '출금 잠김',
    'agent.withdraw.form.lockedHint': '추천 요건을 완료하면 출금이 해제됩니다',
    'agent.withdraw.form.viewRequirements': '요건 보기',
    'agent.withdraw.form.availableLabel': '출금 가능',
    'agent.withdraw.form.pending': '대기 중: {{amount}}',
    'agent.withdraw.form.paidOut': '지급됨: {{amount}}',
    'agent.withdraw.form.walletLabel': 'USDT TRC20 지갑 주소',
    'agent.withdraw.form.walletPlaceholder': '지갑 주소 입력',
    'agent.withdraw.form.walletHint': '에이전트 출금은 USDT TRC20만 가능합니다. 플랫폼 수수료 없음.',
    'agent.withdraw.form.amountLabel': '금액',
    'agent.withdraw.form.amountPlaceholder': '0.00',
    'agent.withdraw.form.availableLine': '가능: {{amount}}',
    'agent.withdraw.form.requestCta': '출금 요청',
    'agent.withdraw.form.submitting': '제출 중…',
    'agent.withdraw.toast.walletRequired': '지갑 주소가 필요합니다',
    'agent.withdraw.toast.amountInvalid': '유효한 금액을 입력하세요',
    'agent.withdraw.toast.amountExceeds': 'Amount exceeds available balance',
    'agent.withdraw.toast.loadFail': 'Failed to load withdrawals',
    'agent.withdraw.toast.submitFail': '출금 제출에 실패했습니다',
    'agent.withdraw.toast.submitted': '출금 요청이 제출되었습니다',
    'agent.withdraw.unlock.titleUnlocked': '출금이 해제되었습니다',
    'agent.withdraw.unlock.titleLocked': '출금이 현재 잠겨 있습니다',
    'agent.withdraw.unlock.subtitle': '아래 두 가지 요건을 완료하면 출금이 활성화됩니다',
    'agent.withdraw.unlock.directLabel': '필요한 직접 추천',
    'agent.withdraw.unlock.indirectLabel': '필요한 간접 추천',
    'agent.withdraw.unlock.loading': '불러오는 중…',
    'agent.withdraw.unlock.loadingTitle': '출금 상태 확인 중…',
    'agent.withdraw.unlock.loadingSubtitle': '추천 진행 상황 및 해제 요건을 불러오는 중입니다',
    'agent.withdraw.form.loadingTitle': '출금 정보 불러오는 중…',
    'agent.withdraw.form.loadingHint': '잔액 및 해제 상태를 불러올 때까지 잠시 기다려 주세요',
    'agent.withdraw.unlock.pctComplete': '{{pct}}% 완료',
    'agent.withdraw.unlock.requirementMet': '요건 충족',
    'agent.withdraw.unlock.moreNeeded': '{{n}}명 더 필요',
    'agent.withdraw.unlock.badgeUnlocked': '출금 해제',
    'agent.withdraw.unlock.badgeLocked': '출금 잠김',
    'agent.withdraw.unlock.footerHint': '두 요건을 모두 충족해야 합니다',
    'agent.withdraw.unlock.minDepositHint':
      '추천 사용자만 해당됩니다(하위 에이전트 제외). 각 사용자는 완료된 입금이 최소 ${{amount}} 이상이어야 합니다.',
    'agent.withdraw.confirm.title': '출금 확인',
    'agent.withdraw.confirm.amount': '출금 금액',
    'agent.withdraw.confirm.fee': '플랫폼 수수료',
    'agent.withdraw.confirm.noFee': '수수료 없음',
    'agent.withdraw.confirm.net': '받을 금액',
    'agent.withdraw.confirm.submitting': '제출 중…',
    'agent.withdraw.confirm.confirm': '확인',
    'agent.withdraw.rules.title': '출금 규칙',
    'agent.withdraw.rules.rule1': '계정 활성화일부터 30일마다 이용 가능',
    'agent.withdraw.rules.rule2': '커미션 잔액만 출금 가능 — 에이전트는 원금을 투자하지 않습니다',
    'agent.withdraw.rules.rule3': 'USDT TRC20 지갑만 — 다른 방법 불가',
    'agent.withdraw.rules.rule4': '에이전트 출금에 플랫폼 수수료 없음',
    'agent.withdraw.rules.rule5': '첫 출금 전에 두 추천 요건을 충족해야 합니다',
    'agent.withdraw.rules.processingNote': '출금 요청은 제출 후 24–48시간 내 검토·처리됩니다.',
    'agent.withdraw.rules.windowActive': '출금 기간이 활성화되었습니다. 지금 요청할 수 있습니다.',
    'agent.withdrawLogs.sectionTitle': '출금 내역',
    'agent.withdrawLogs.loading': '출금 불러오는 중…',
    'agent.withdrawLogs.emptyTitle': '아직 출금이 없습니다',
    'agent.withdrawLogs.emptyDesc': '출금 내역이 여기에 표시됩니다',
    'agent.withdrawLogs.emptyLoadingHint': '잠시만 기다려 주세요…',
    'agent.withdrawLogs.col.date': '날짜',
    'agent.withdrawLogs.col.amount': '금액',
    'agent.withdrawLogs.col.wallet': '지갑 주소',
    'agent.withdrawLogs.col.status': '상태',
    'agent.withdrawLogs.col.txid': 'TXID',
    'agent.withdrawLogs.showingCount': '{{n}}건의 출금 표시',
  },
  'zh-CN': {
    'agent.withdraw.form.title': '提取佣金',
    'agent.withdraw.form.lockedTitle': '提现已锁定',
    'agent.withdraw.form.lockedHint': '完成推荐要求以解锁提现',
    'agent.withdraw.form.viewRequirements': '查看要求',
    'agent.withdraw.form.availableLabel': '可提现',
    'agent.withdraw.form.pending': '待处理：{{amount}}',
    'agent.withdraw.form.paidOut': '已支付：{{amount}}',
    'agent.withdraw.form.walletLabel': 'USDT TRC20 钱包地址',
    'agent.withdraw.form.walletPlaceholder': '输入钱包地址',
    'agent.withdraw.form.walletHint': '代理提现仅支持 USDT TRC20。无平台手续费。',
    'agent.withdraw.form.amountLabel': '金额',
    'agent.withdraw.form.amountPlaceholder': '0.00',
    'agent.withdraw.form.availableLine': '可用：{{amount}}',
    'agent.withdraw.form.requestCta': '申请提现',
    'agent.withdraw.form.submitting': '提交中…',
    'agent.withdraw.toast.walletRequired': '钱包地址为必填项',
    'agent.withdraw.toast.amountInvalid': '请输入有效金额',
    'agent.withdraw.toast.amountExceeds': 'Amount exceeds available balance',
    'agent.withdraw.toast.loadFail': 'Failed to load withdrawals',
    'agent.withdraw.toast.submitFail': '提现提交失败',
    'agent.withdraw.toast.submitted': '提现申请已提交',
    'agent.withdraw.unlock.titleUnlocked': '提现已解锁',
    'agent.withdraw.unlock.titleLocked': '提现当前已锁定',
    'agent.withdraw.unlock.subtitle': '完成以下两项要求以启用提现',
    'agent.withdraw.unlock.directLabel': '所需直接推荐',
    'agent.withdraw.unlock.indirectLabel': '所需间接推荐',
    'agent.withdraw.unlock.loading': '加载中…',
    'agent.withdraw.unlock.loadingTitle': '正在检查提现状态…',
    'agent.withdraw.unlock.loadingSubtitle': '正在加载您的推荐进度和解锁要求',
    'agent.withdraw.form.loadingTitle': '正在加载提现详情…',
    'agent.withdraw.form.loadingHint': '请稍候，正在加载余额和解锁状态',
    'agent.withdraw.unlock.pctComplete': '已完成 {{pct}}%',
    'agent.withdraw.unlock.requirementMet': '已满足要求',
    'agent.withdraw.unlock.moreNeeded': '还需 {{n}}',
    'agent.withdraw.unlock.badgeUnlocked': '提现已解锁',
    'agent.withdraw.unlock.badgeLocked': '提现已锁定',
    'agent.withdraw.unlock.footerHint': '必须满足两项要求',
    'agent.withdraw.unlock.minDepositHint':
      '仅统计推荐用户（不含下级代理）。每位用户须至少有 ${{amount}} 已完成入金。',
    'agent.withdraw.confirm.title': '确认提现',
    'agent.withdraw.confirm.amount': '提现金额',
    'agent.withdraw.confirm.fee': '平台手续费',
    'agent.withdraw.confirm.noFee': '无手续费',
    'agent.withdraw.confirm.net': '您将收到',
    'agent.withdraw.confirm.submitting': '提交中…',
    'agent.withdraw.confirm.confirm': '确认',
    'agent.withdraw.rules.title': '提现规则',
    'agent.withdraw.rules.rule1': '自账户激活日起每 30 天可提现一次',
    'agent.withdraw.rules.rule2': '仅可提取佣金余额 — 代理不投资本金',
    'agent.withdraw.rules.rule3': '仅支持 USDT TRC20 钱包 — 无其他方式',
    'agent.withdraw.rules.rule4': '代理提现无平台手续费',
    'agent.withdraw.rules.rule5': '首次提现前须满足两项推荐要求',
    'agent.withdraw.rules.processingNote': '提现申请在提交后 24–48 小时内审核处理。',
    'agent.withdraw.rules.windowActive': '提现窗口已开放。您现在可以提交申请。',
    'agent.withdrawLogs.sectionTitle': '提现记录',
    'agent.withdrawLogs.loading': '正在加载提现…',
    'agent.withdrawLogs.emptyTitle': '尚无提现',
    'agent.withdrawLogs.emptyDesc': '您的提现记录将显示在这里',
    'agent.withdrawLogs.emptyLoadingHint': '请稍候…',
    'agent.withdrawLogs.col.date': '日期',
    'agent.withdrawLogs.col.amount': '金额',
    'agent.withdrawLogs.col.wallet': '钱包地址',
    'agent.withdrawLogs.col.status': '状态',
    'agent.withdrawLogs.col.txid': 'TXID',
    'agent.withdrawLogs.showingCount': '显示 {{n}} 笔提现',
  },
  pt: {
    'agent.withdraw.form.title': 'Sacar comissão',
    'agent.withdraw.form.lockedTitle': 'Saques bloqueados',
    'agent.withdraw.form.lockedHint': 'Complete os requisitos de indicação para desbloquear',
    'agent.withdraw.form.viewRequirements': 'Ver requisitos',
    'agent.withdraw.form.availableLabel': 'Disponível para saque',
    'agent.withdraw.form.pending': 'Pendente: {{amount}}',
    'agent.withdraw.form.paidOut': 'Pago: {{amount}}',
    'agent.withdraw.form.walletLabel': 'Endereço da carteira USDT TRC20',
    'agent.withdraw.form.walletPlaceholder': 'Digite o endereço da carteira',
    'agent.withdraw.form.walletHint': 'Saques de agente apenas para USDT TRC20. Sem taxas da plataforma.',
    'agent.withdraw.form.amountLabel': 'Valor',
    'agent.withdraw.form.amountPlaceholder': '0.00',
    'agent.withdraw.form.availableLine': 'Disponível: {{amount}}',
    'agent.withdraw.form.requestCta': 'Solicitar saque',
    'agent.withdraw.form.submitting': 'Enviando…',
    'agent.withdraw.toast.walletRequired': 'O endereço da carteira é obrigatório',
    'agent.withdraw.toast.amountInvalid': 'Digite um valor válido',
    'agent.withdraw.toast.amountExceeds': 'Amount exceeds available balance',
    'agent.withdraw.toast.loadFail': 'Failed to load withdrawals',
    'agent.withdraw.toast.submitFail': 'Falha ao enviar o saque',
    'agent.withdraw.toast.submitted': 'Pedido de saque enviado',
    'agent.withdraw.unlock.titleUnlocked': 'Saques desbloqueados',
    'agent.withdraw.unlock.titleLocked': 'Saques bloqueados no momento',
    'agent.withdraw.unlock.subtitle': 'Complete os dois requisitos abaixo para ativar saques',
    'agent.withdraw.unlock.directLabel': 'Indicações diretas necessárias',
    'agent.withdraw.unlock.indirectLabel': 'Indicações indiretas necessárias',
    'agent.withdraw.unlock.loading': 'Carregando…',
    'agent.withdraw.unlock.loadingTitle': 'Verificando status de saque…',
    'agent.withdraw.unlock.loadingSubtitle': 'Carregando seu progresso de indicações e requisitos de desbloqueio',
    'agent.withdraw.form.loadingTitle': 'Carregando detalhes do saque…',
    'agent.withdraw.form.loadingHint': 'Aguarde enquanto carregamos seu saldo e status de desbloqueio',
    'agent.withdraw.unlock.pctComplete': '{{pct}}% concluído',
    'agent.withdraw.unlock.requirementMet': 'Requisito atendido',
    'agent.withdraw.unlock.moreNeeded': 'mais {{n}}',
    'agent.withdraw.unlock.badgeUnlocked': 'Saques desbloqueados',
    'agent.withdraw.unlock.badgeLocked': 'Saques bloqueados',
    'agent.withdraw.unlock.footerHint': 'Ambos os requisitos devem ser atendidos',
    'agent.withdraw.unlock.minDepositHint':
      'Apenas usuários indicados contam (não sub-agentes). Cada um precisa de pelo menos ${{amount}} em depósitos concluídos.',
    'agent.withdraw.confirm.title': 'Confirmar saque',
    'agent.withdraw.confirm.amount': 'Valor do saque',
    'agent.withdraw.confirm.fee': 'Taxa da plataforma',
    'agent.withdraw.confirm.noFee': 'Sem taxa',
    'agent.withdraw.confirm.net': 'Você receberá',
    'agent.withdraw.confirm.submitting': 'Enviando…',
    'agent.withdraw.confirm.confirm': 'Confirmar',
    'agent.withdraw.rules.title': 'Regras de saque',
    'agent.withdraw.rules.rule1': 'Disponível a cada 30 dias a partir da ativação da conta',
    'agent.withdraw.rules.rule2': 'Apenas saldo de comissão pode ser sacado — agentes não investem capital',
    'agent.withdraw.rules.rule3': 'Somente carteira USDT TRC20 — sem outros métodos',
    'agent.withdraw.rules.rule4': 'Sem taxas da plataforma em saques de agente',
    'agent.withdraw.rules.rule5': 'Ambos os requisitos de indicação antes do primeiro saque',
    'agent.withdraw.rules.processingNote': 'Pedidos são revisados e processados em 24–48 horas após o envio.',
    'agent.withdraw.rules.windowActive': 'Janela de saque ativa. Você pode enviar pedidos agora.',
    'agent.withdrawLogs.sectionTitle': 'Histórico de saques',
    'agent.withdrawLogs.loading': 'Carregando saques…',
    'agent.withdrawLogs.emptyTitle': 'Nenhum saque ainda',
    'agent.withdrawLogs.emptyDesc': 'Seu histórico de saques aparecerá aqui',
    'agent.withdrawLogs.emptyLoadingHint': 'Aguarde…',
    'agent.withdrawLogs.col.date': 'Data',
    'agent.withdrawLogs.col.amount': 'Valor',
    'agent.withdrawLogs.col.wallet': 'Endereço da carteira',
    'agent.withdrawLogs.col.status': 'Status',
    'agent.withdrawLogs.col.txid': 'TXID',
    'agent.withdrawLogs.showingCount': 'Mostrando {{n}} saques',
  },
  it: {
    'agent.withdraw.form.title': 'Preleva commissione',
    'agent.withdraw.form.lockedTitle': 'Prelievi bloccati',
    'agent.withdraw.form.lockedHint': 'Completa i requisiti di referral per sbloccare',
    'agent.withdraw.form.viewRequirements': 'Vedi requisiti',
    'agent.withdraw.form.availableLabel': 'Disponibile per prelievo',
    'agent.withdraw.form.pending': 'In attesa: {{amount}}',
    'agent.withdraw.form.paidOut': 'Pagato: {{amount}}',
    'agent.withdraw.form.walletLabel': 'Indirizzo wallet USDT TRC20',
    'agent.withdraw.form.walletPlaceholder': 'Inserisci indirizzo wallet',
    'agent.withdraw.form.walletHint': 'Prelievi agente solo su USDT TRC20. Nessuna commissione piattaforma.',
    'agent.withdraw.form.amountLabel': 'Importo',
    'agent.withdraw.form.amountPlaceholder': '0.00',
    'agent.withdraw.form.availableLine': 'Disponibile: {{amount}}',
    'agent.withdraw.form.requestCta': 'Richiedi prelievo',
    'agent.withdraw.form.submitting': 'Invio…',
    'agent.withdraw.toast.walletRequired': 'L\'indirizzo wallet è obbligatorio',
    'agent.withdraw.toast.amountInvalid': 'Inserisci un importo valido',
    'agent.withdraw.toast.amountExceeds': 'Amount exceeds available balance',
    'agent.withdraw.toast.loadFail': 'Failed to load withdrawals',
    'agent.withdraw.toast.submitFail': 'Invio prelievo non riuscito',
    'agent.withdraw.toast.submitted': 'Richiesta di prelievo inviata',
    'agent.withdraw.unlock.titleUnlocked': 'Prelievi sbloccati',
    'agent.withdraw.unlock.titleLocked': 'Prelievi attualmente bloccati',
    'agent.withdraw.unlock.subtitle': 'Completa entrambi i requisiti sotto per attivare i prelievi',
    'agent.withdraw.unlock.directLabel': 'Referral diretti richiesti',
    'agent.withdraw.unlock.indirectLabel': 'Referral indiretti richiesti',
    'agent.withdraw.unlock.loading': 'Caricamento…',
    'agent.withdraw.unlock.loadingTitle': 'Verifica stato prelievi…',
    'agent.withdraw.unlock.loadingSubtitle': 'Caricamento progresso referral e requisiti di sblocco',
    'agent.withdraw.form.loadingTitle': 'Caricamento dettagli prelievo…',
    'agent.withdraw.form.loadingHint': 'Attendere il caricamento del saldo e dello stato di sblocco',
    'agent.withdraw.unlock.pctComplete': '{{pct}}% completato',
    'agent.withdraw.unlock.requirementMet': 'Requisito soddisfatto',
    'agent.withdraw.unlock.moreNeeded': 'altri {{n}}',
    'agent.withdraw.unlock.badgeUnlocked': 'Prelievi sbloccati',
    'agent.withdraw.unlock.badgeLocked': 'Prelievi bloccati',
    'agent.withdraw.unlock.footerHint': 'Entrambi i requisiti devono essere soddisfatti',
    'agent.withdraw.unlock.minDepositHint':
      'Contano solo gli utenti referenziati (non i sub-agent). Ognuno deve avere almeno ${{amount}} in depositi completati.',
    'agent.withdraw.confirm.title': 'Conferma prelievo',
    'agent.withdraw.confirm.amount': 'Importo prelievo',
    'agent.withdraw.confirm.fee': 'Commissione piattaforma',
    'agent.withdraw.confirm.noFee': 'Nessuna commissione',
    'agent.withdraw.confirm.net': 'Riceverai',
    'agent.withdraw.confirm.submitting': 'Invio…',
    'agent.withdraw.confirm.confirm': 'Conferma',
    'agent.withdraw.rules.title': 'Regole di prelievo',
    'agent.withdraw.rules.rule1': 'Disponibile ogni 30 giorni dalla attivazione account',
    'agent.withdraw.rules.rule2': 'Solo il saldo commissioni è prelevabile — gli agenti non investono capitale',
    'agent.withdraw.rules.rule3': 'Solo wallet USDT TRC20 — nessun altro metodo',
    'agent.withdraw.rules.rule4': 'Nessuna commissione piattaforma sui prelievi agente',
    'agent.withdraw.rules.rule5': 'Entrambi i requisiti referral prima del primo prelievo',
    'agent.withdraw.rules.processingNote': 'Le richieste sono esaminate e elaborate entro 24–48 ore dalla presentazione.',
    'agent.withdraw.rules.windowActive': 'Finestra prelievo attiva. Puoi inviare richieste ora.',
    'agent.withdrawLogs.sectionTitle': 'Storico prelievi',
    'agent.withdrawLogs.loading': 'Caricamento prelievi…',
    'agent.withdrawLogs.emptyTitle': 'Nessun prelievo ancora',
    'agent.withdrawLogs.emptyDesc': 'Lo storico prelievi apparirà qui',
    'agent.withdrawLogs.emptyLoadingHint': 'Attendere…',
    'agent.withdrawLogs.col.date': 'Data',
    'agent.withdrawLogs.col.amount': 'Importo',
    'agent.withdrawLogs.col.wallet': 'Indirizzo wallet',
    'agent.withdrawLogs.col.status': 'Stato',
    'agent.withdrawLogs.col.txid': 'TXID',
    'agent.withdrawLogs.showingCount': 'Visualizzazione di {{n}} prelievi',
  },
  ru: {
    'agent.withdraw.form.title': 'Вывести комиссию',
    'agent.withdraw.form.lockedTitle': 'Вывод заблокирован',
    'agent.withdraw.form.lockedHint': 'Выполните требования по рефералам для разблокировки',
    'agent.withdraw.form.viewRequirements': 'Смотреть требования',
    'agent.withdraw.form.availableLabel': 'Доступно к выводу',
    'agent.withdraw.form.pending': 'В ожидании: {{amount}}',
    'agent.withdraw.form.paidOut': 'Выплачено: {{amount}}',
    'agent.withdraw.form.walletLabel': 'Адрес кошелька USDT TRC20',
    'agent.withdraw.form.walletPlaceholder': 'Введите адрес кошелька',
    'agent.withdraw.form.walletHint': 'Вывод агентов только на USDT TRC20. Без комиссии платформы.',
    'agent.withdraw.form.amountLabel': 'Сумма',
    'agent.withdraw.form.amountPlaceholder': '0.00',
    'agent.withdraw.form.availableLine': 'Доступно: {{amount}}',
    'agent.withdraw.form.requestCta': 'Запросить вывод',
    'agent.withdraw.form.submitting': 'Отправка…',
    'agent.withdraw.toast.walletRequired': 'Требуется адрес кошелька',
    'agent.withdraw.toast.amountInvalid': 'Введите корректную сумму',
    'agent.withdraw.toast.amountExceeds': 'Amount exceeds available balance',
    'agent.withdraw.toast.loadFail': 'Failed to load withdrawals',
    'agent.withdraw.toast.submitFail': 'Не удалось отправить вывод',
    'agent.withdraw.toast.submitted': 'Запрос на вывод отправлен',
    'agent.withdraw.unlock.titleUnlocked': 'Вывод разблокирован',
    'agent.withdraw.unlock.titleLocked': 'Вывод сейчас заблокирован',
    'agent.withdraw.unlock.subtitle': 'Выполните оба требования ниже, чтобы активировать вывод',
    'agent.withdraw.unlock.directLabel': 'Требуется прямых рефералов',
    'agent.withdraw.unlock.indirectLabel': 'Требуется косвенных рефералов',
    'agent.withdraw.unlock.loading': 'Загрузка…',
    'agent.withdraw.unlock.loadingTitle': 'Проверка статуса вывода…',
    'agent.withdraw.unlock.loadingSubtitle': 'Загрузка прогресса рефералов и требований для разблокировки',
    'agent.withdraw.form.loadingTitle': 'Загрузка данных о выводе…',
    'agent.withdraw.form.loadingHint': 'Подождите, загружаем баланс и статус разблокировки',
    'agent.withdraw.unlock.pctComplete': '{{pct}}% выполнено',
    'agent.withdraw.unlock.requirementMet': 'Требование выполнено',
    'agent.withdraw.unlock.moreNeeded': 'ещё {{n}}',
    'agent.withdraw.unlock.badgeUnlocked': 'Вывод разблокирован',
    'agent.withdraw.unlock.badgeLocked': 'Вывод заблокирован',
    'agent.withdraw.unlock.footerHint': 'Оба требования должны быть выполнены',
    'agent.withdraw.unlock.minDepositHint':
      'Учитываются только приглашённые пользователи (не суб-агенты). У каждого должно быть не менее ${{amount}} завершённых депозитов.',
    'agent.withdraw.confirm.title': 'Подтвердить вывод',
    'agent.withdraw.confirm.amount': 'Сумма вывода',
    'agent.withdraw.confirm.fee': 'Комиссия платформы',
    'agent.withdraw.confirm.noFee': 'Без комиссии',
    'agent.withdraw.confirm.net': 'Вы получите',
    'agent.withdraw.confirm.submitting': 'Отправка…',
    'agent.withdraw.confirm.confirm': 'Подтвердить',
    'agent.withdraw.rules.title': 'Правила вывода',
    'agent.withdraw.rules.rule1': 'Доступно каждые 30 дней с даты активации аккаунта',
    'agent.withdraw.rules.rule2': 'Можно вывести только комиссионный баланс — агенты не инвестируют капитал',
    'agent.withdraw.rules.rule3': 'Только кошелёк USDT TRC20 — другие методы недоступны',
    'agent.withdraw.rules.rule4': 'Без комиссии платформы на выводы агентов',
    'agent.withdraw.rules.rule5': 'Оба требования по рефералам до первого вывода',
    'agent.withdraw.rules.processingNote': 'Заявки рассматриваются и обрабатываются в течение 24–48 часов после подачи.',
    'agent.withdraw.rules.windowActive': 'Окно вывода активно. Можно отправлять заявки.',
    'agent.withdrawLogs.sectionTitle': 'История выводов',
    'agent.withdrawLogs.loading': 'Загрузка выводов…',
    'agent.withdrawLogs.emptyTitle': 'Выводов пока нет',
    'agent.withdrawLogs.emptyDesc': 'История выводов появится здесь',
    'agent.withdrawLogs.emptyLoadingHint': 'Подождите…',
    'agent.withdrawLogs.col.date': 'Дата',
    'agent.withdrawLogs.col.amount': 'Сумма',
    'agent.withdrawLogs.col.wallet': 'Адрес кошелька',
    'agent.withdrawLogs.col.status': 'Статус',
    'agent.withdrawLogs.col.txid': 'TXID',
    'agent.withdrawLogs.showingCount': 'Показано выводов: {{n}}',
  },
  bn: {
    'agent.withdraw.form.title': 'কমিশন উত্তোলন',
    'agent.withdraw.form.lockedTitle': 'উত্তোলন লক',
    'agent.withdraw.form.lockedHint': 'আনলক করতে রেফারেল শর্ত পূরণ করুন',
    'agent.withdraw.form.viewRequirements': 'শর্ত দেখুন',
    'agent.withdraw.form.availableLabel': 'উত্তোলনযোগ্য',
    'agent.withdraw.form.pending': 'মুলতুবি: {{amount}}',
    'agent.withdraw.form.paidOut': 'পরিশোধিত: {{amount}}',
    'agent.withdraw.form.walletLabel': 'USDT TRC20 ওয়ালেট ঠিকানা',
    'agent.withdraw.form.walletPlaceholder': 'ওয়ালেট ঠিকানা লিখুন',
    'agent.withdraw.form.walletHint': 'এজেন্ট উত্তোলন শুধু USDT TRC20-এ। প্ল্যাটফর্ম ফি নেই।',
    'agent.withdraw.form.amountLabel': 'পরিমাণ',
    'agent.withdraw.form.amountPlaceholder': '0.00',
    'agent.withdraw.form.availableLine': 'উপলব্ধ: {{amount}}',
    'agent.withdraw.form.requestCta': 'উত্তোলনের অনুরোধ',
    'agent.withdraw.form.submitting': 'জমা দেওয়া হচ্ছে…',
    'agent.withdraw.toast.walletRequired': 'ওয়ালেট ঠিকানা প্রয়োজন',
    'agent.withdraw.toast.amountInvalid': 'বৈধ পরিমাণ লিখুন',
    'agent.withdraw.toast.amountExceeds': 'Amount exceeds available balance',
    'agent.withdraw.toast.loadFail': 'Failed to load withdrawals',
    'agent.withdraw.toast.submitFail': 'উত্তোলন জমা দিতে ব্যর্থ',
    'agent.withdraw.toast.submitted': 'উত্তোলনের অনুরোধ জমা হয়েছে',
    'agent.withdraw.unlock.titleUnlocked': 'উত্তোলন আনলক',
    'agent.withdraw.unlock.titleLocked': 'উত্তোলন বর্তমানে লক',
    'agent.withdraw.unlock.subtitle': 'উত্তোলন সক্রিয় করতে নিচের দুটি শর্ত পূরণ করুন',
    'agent.withdraw.unlock.directLabel': 'প্রয়োজনীয় সরাসরি রেফারেল',
    'agent.withdraw.unlock.indirectLabel': 'প্রয়োজনীয় পরোক্ষ রেফারেল',
    'agent.withdraw.unlock.loading': 'লোড হচ্ছে…',
    'agent.withdraw.unlock.loadingTitle': 'উত্তোলনের অবস্থা যাচাই করা হচ্ছে…',
    'agent.withdraw.unlock.loadingSubtitle': 'আপনার রেফারেল অগ্রগতি ও আনলক শর্ত লোড হচ্ছে',
    'agent.withdraw.form.loadingTitle': 'উত্তোলনের বিবরণ লোড হচ্ছে…',
    'agent.withdraw.form.loadingHint': 'ব্যালেন্স ও আনলক অবস্থা লোড হওয়া পর্যন্ত অপেক্ষা করুন',
    'agent.withdraw.unlock.pctComplete': '{{pct}}% সম্পন্ন',
    'agent.withdraw.unlock.requirementMet': 'শর্ত পূরণ হয়েছে',
    'agent.withdraw.unlock.moreNeeded': 'আরও {{n}}',
    'agent.withdraw.unlock.badgeUnlocked': 'উত্তোলন আনলক',
    'agent.withdraw.unlock.badgeLocked': 'উত্তোলন লক',
    'agent.withdraw.unlock.footerHint': 'দুটি শর্তই পূরণ করতে হবে',
    'agent.withdraw.unlock.minDepositHint':
      'শুধু রেফার করা ব্যবহারকারী গণনা হয় (সাব-এজেন্ট নয়)। প্রত্যেকের সম্পন্ন জমা কমপক্ষে ${{amount}} হতে হবে।',
    'agent.withdraw.confirm.title': 'উত্তোলন নিশ্চিত করুন',
    'agent.withdraw.confirm.amount': 'উত্তোলনের পরিমাণ',
    'agent.withdraw.confirm.fee': 'প্ল্যাটফর্ম ফি',
    'agent.withdraw.confirm.noFee': 'কোনো ফি নেই',
    'agent.withdraw.confirm.net': 'আপনি পাবেন',
    'agent.withdraw.confirm.submitting': 'জমা দেওয়া হচ্ছে…',
    'agent.withdraw.confirm.confirm': 'নিশ্চিত',
    'agent.withdraw.rules.title': 'উত্তোলনের নিয়ম',
    'agent.withdraw.rules.rule1': 'অ্যাকাউন্ট সক্রিয়করণের ৩০ দিন পর পর উপলব্ধ',
    'agent.withdraw.rules.rule2': 'শুধু কমিশন ব্যালেন্স উত্তোলনযোগ্য — এজেন্টরা মূলধন বিনিয়োগ করে না',
    'agent.withdraw.rules.rule3': 'শুধু USDT TRC20 ওয়ালেট — অন্য পদ্ধতি নেই',
    'agent.withdraw.rules.rule4': 'এজেন্ট উত্তোলনে প্ল্যাটফর্ম ফি নেই',
    'agent.withdraw.rules.rule5': 'প্রথম উত্তোলনের আগে দুটি রেফারেল শর্ত পূরণ',
    'agent.withdraw.rules.processingNote': 'অনুরোধ জমা দেওয়ার ২৪–৪৮ ঘণ্টার মধ্যে পর্যালোচনা ও প্রক্রিয়া হয়।',
    'agent.withdraw.rules.windowActive': 'উত্তোলন উইন্ডো সক্রিয়। এখন অনুরোধ পাঠাতে পারেন।',
    'agent.withdrawLogs.sectionTitle': 'উত্তোলনের ইতিহাস',
    'agent.withdrawLogs.loading': 'উত্তোলন লোড হচ্ছে…',
    'agent.withdrawLogs.emptyTitle': 'এখনও কোনো উত্তোলন নেই',
    'agent.withdrawLogs.emptyDesc': 'আপনার উত্তোলনের ইতিহাস এখানে দেখা যাবে',
    'agent.withdrawLogs.emptyLoadingHint': 'অনুগ্রহ করে অপেক্ষা করুন…',
    'agent.withdrawLogs.col.date': 'তারিখ',
    'agent.withdrawLogs.col.amount': 'পরিমাণ',
    'agent.withdrawLogs.col.wallet': 'ওয়ালেট ঠিকানা',
    'agent.withdrawLogs.col.status': 'স্থিতি',
    'agent.withdrawLogs.col.txid': 'TXID',
    'agent.withdrawLogs.showingCount': '{{n}}টি উত্তোলন দেখানো হচ্ছে',
  },
  hi: {
    'agent.withdraw.form.title': 'कमीशन निकालें',
    'agent.withdraw.form.lockedTitle': 'निकासी लॉक',
    'agent.withdraw.form.lockedHint': 'अनलॉक करने के लिए रेफरल आवश्यकताएँ पूरी करें',
    'agent.withdraw.form.viewRequirements': 'आवश्यकताएँ देखें',
    'agent.withdraw.form.availableLabel': 'निकासी के लिए उपलब्ध',
    'agent.withdraw.form.pending': 'लंबित: {{amount}}',
    'agent.withdraw.form.paidOut': 'भुगतान: {{amount}}',
    'agent.withdraw.form.walletLabel': 'USDT TRC20 वॉलेट पता',
    'agent.withdraw.form.walletPlaceholder': 'वॉलेट पता दर्ज करें',
    'agent.withdraw.form.walletHint': 'एजेंट निकासी केवल USDT TRC20 पर। कोई प्लेटफ़ॉर्म शुल्क नहीं।',
    'agent.withdraw.form.amountLabel': 'राशि',
    'agent.withdraw.form.amountPlaceholder': '0.00',
    'agent.withdraw.form.availableLine': 'उपलब्ध: {{amount}}',
    'agent.withdraw.form.requestCta': 'निकासी का अनुरोध',
    'agent.withdraw.form.submitting': 'जमा हो रहा है…',
    'agent.withdraw.toast.walletRequired': 'वॉलेट पता आवश्यक है',
    'agent.withdraw.toast.amountInvalid': 'मान्य राशि दर्ज करें',
    'agent.withdraw.toast.amountExceeds': 'Amount exceeds available balance',
    'agent.withdraw.toast.loadFail': 'Failed to load withdrawals',
    'agent.withdraw.toast.submitFail': 'निकासी जमा करने में विफल',
    'agent.withdraw.toast.submitted': 'निकासी अनुरोध जमा हो गया',
    'agent.withdraw.unlock.titleUnlocked': 'निकासी अनलॉक',
    'agent.withdraw.unlock.titleLocked': 'निकासी वर्तमान में लॉक',
    'agent.withdraw.unlock.subtitle': 'निकासी सक्षम करने के लिए नीचे दोनों आवश्यकताएँ पूरी करें',
    'agent.withdraw.unlock.directLabel': 'आवश्यक प्रत्यक्ष रेफरल',
    'agent.withdraw.unlock.indirectLabel': 'आवश्यक अप्रत्यक्ष रेफरल',
    'agent.withdraw.unlock.loading': 'लोड हो रहा है…',
    'agent.withdraw.unlock.loadingTitle': 'निकासी स्थिति जाँची जा रही है…',
    'agent.withdraw.unlock.loadingSubtitle': 'आपकी रेफरल प्रगति और अनलॉक आवश्यकताएँ लोड हो रही हैं',
    'agent.withdraw.form.loadingTitle': 'निकासी विवरण लोड हो रहे हैं…',
    'agent.withdraw.form.loadingHint': 'कृपया प्रतीक्षा करें — बैलेंस और अनलॉक स्थिति लोड हो रही है',
    'agent.withdraw.unlock.pctComplete': '{{pct}}% पूर्ण',
    'agent.withdraw.unlock.requirementMet': 'आवश्यकता पूरी',
    'agent.withdraw.unlock.moreNeeded': '{{n}} और चाहिए',
    'agent.withdraw.unlock.badgeUnlocked': 'निकासी अनलॉक',
    'agent.withdraw.unlock.badgeLocked': 'निकासी लॉक',
    'agent.withdraw.unlock.footerHint': 'दोनों आवश्यकताएँ पूरी होनी चाहिए',
    'agent.withdraw.unlock.minDepositHint':
      'केवल रेफ़र किए गए उपयोगकर्ता गिने जाते हैं (उप-एजेंट नहीं)। प्रत्येक के पास पूर्ण जमा में कम से कम ${{amount}} होना चाहिए।',
    'agent.withdraw.confirm.title': 'निकासी की पुष्टि',
    'agent.withdraw.confirm.amount': 'निकासी राशि',
    'agent.withdraw.confirm.fee': 'प्लेटफ़ॉर्म शुल्क',
    'agent.withdraw.confirm.noFee': 'कोई शुल्क नहीं',
    'agent.withdraw.confirm.net': 'आपको मिलेगा',
    'agent.withdraw.confirm.submitting': 'जमा हो रहा है…',
    'agent.withdraw.confirm.confirm': 'पुष्टि करें',
    'agent.withdraw.rules.title': 'निकासी नियम',
    'agent.withdraw.rules.rule1': 'खाता सक्रियण की तारीख से हर 30 दिन में उपलब्ध',
    'agent.withdraw.rules.rule2': 'केवल कमीशन शेष निकाला जा सकता है — एजेंट मूलधन निवेश नहीं करते',
    'agent.withdraw.rules.rule3': 'केवल USDT TRC20 वॉलेट — अन्य तरीके नहीं',
    'agent.withdraw.rules.rule4': 'एजेंट निकासी पर कोई प्लेटफ़ॉर्म शुल्क नहीं',
    'agent.withdraw.rules.rule5': 'पहली निकासी से पहले दोनों रेफरल आवश्यकताएँ',
    'agent.withdraw.rules.processingNote': 'अनुरोध जमा के 24–48 घंटे के भीतर समीक्षा और प्रसंस्करण होता है।',
    'agent.withdraw.rules.windowActive': 'निकासी विंडो सक्रिय है। अब अनुरोध भेज सकते हैं।',
    'agent.withdrawLogs.sectionTitle': 'निकासी इतिहास',
    'agent.withdrawLogs.loading': 'निकासी लोड हो रही है…',
    'agent.withdrawLogs.emptyTitle': 'अभी कोई निकासी नहीं',
    'agent.withdrawLogs.emptyDesc': 'आपका निकासी इतिहास यहाँ दिखेगा',
    'agent.withdrawLogs.emptyLoadingHint': 'कृपया प्रतीक्षा करें…',
    'agent.withdrawLogs.col.date': 'तारीख',
    'agent.withdrawLogs.col.amount': 'राशि',
    'agent.withdrawLogs.col.wallet': 'वॉलेट पता',
    'agent.withdrawLogs.col.status': 'स्थिति',
    'agent.withdrawLogs.col.txid': 'TXID',
    'agent.withdrawLogs.showingCount': '{{n}} निकासी दिखाई जा रही हैं',
  },
};
